import type { FunctionViewModel } from '@trinnvis/dabih-api-client';
import type { NameEntry } from './selectors/employees/name-entry';
import { joinWithAnd } from '../utilities/text';

export function functionNameWithAssignedNames(
  functionUuid: string | undefined,
  functions: FunctionViewModel[],
  employees: NameEntry[],
): string {
  const func = functions.find((f) => {
    return f.uuid === functionUuid;
  });
  if (func) {
    let employeeNamesText = '';
    if (func.type !== 'COMMON') {
      let employeeNames = employees
        .filter((name) => {
          return func.employees.includes(name.uuid);
        })
        .map((name) => {
          return name.name;
        });
      if (employeeNames.length === 0) {
        employeeNames = ['ingen'];
      }
      employeeNamesText = ' (' + joinWithAnd(employeeNames) + ')';
    }
    return func.name + employeeNamesText;
  }
  return '';
}
